import { StateToken } from '@ngxs/store';
import { EnvironmentStateModel } from './environment.state-model';

export const ENVIRONMENT_STATE_TOKEN = new StateToken<EnvironmentStateModel>(
  'environment'
);
